/**
 * `perPoolNegativeControls`: the pipeline filters each pool's samples by that pool's negative controls
 * only, and leaves a pool without controls unfiltered. Switches the Pools step's copy and nothing else;
 * turn it on once that pipeline change is deployed (airflow-dags PR #74).
 */
export const orderWizardSettings = {
  perPoolNegativeControls: false
} as const

const POOL_DEFINITION =
  'A pool is a set of samples plus the negative controls that belong to them, usually one PCR plate or extraction batch.'

/**
 * What the Pools step tells the lab about pools and their negative controls. `withoutControl` takes what
 * lacks the control ("pool 2", "pools 2 and 3", "the pool") and whether that is more than one pool.
 */
export const poolCopy = (
  perPool: boolean = orderWizardSettings.perPoolNegativeControls
): { intro: string; withoutControl: (label: string, several: boolean) => string } =>
  perPool
    ? {
        intro: `${POOL_DEFINITION} Each pool's negative controls filter only that pool's samples.`,
        withoutControl: (label: string) => `Samples in ${label} have no negative control, so they won't be filtered`
      }
    : {
        intro: `${POOL_DEFINITION} Put each pool's negative controls in that pool.`,
        withoutControl: (label: string, several: boolean) =>
          `${label.charAt(0).toUpperCase()}${label.slice(1)} ${several ? 'have' : 'has'} no negative control`
      }
